import { DESCRIPTION_COPY_LIMITS, TITLE_COPY_LIMITS } from "../copy-policy";
export const promo2ColumnSchema = {
    componentId: "Promo2Column",
    scalarSlots: [
        { key: "title", ...TITLE_COPY_LIMITS, label: "Title", type: "text" },
        { key: "ctaLabel", label: "CTA label", type: "text" },
        { key: "ctaHref", label: "CTA URL", type: "url" },
    ],
    mediaSlots: [],
    documentSlots: [
        { key: "description", ...DESCRIPTION_COPY_LIMITS, label: "Description" },
    ],
};
//# sourceMappingURL=promo-2-column.js.map